export const SET_LANG = 'SET_LANG'